module.exports = __webpack_public_path__ + "img/login_companydemo.5cf30959.svg";